import i18n from "@/libs/i18n";

export default {
  translateValidations(error, key) {
    return i18n
      .t(`g.alert.${error.replace(i18n.t(key), "template")}`)
      .replace("&&", i18n.t(key));
  },
};
